const CONTENT_TOKEN_REGEX = /(https?:\/\/[^\s]+|www\.[^\s]+\.[a-z]{2,}[^\s]*|(?<!@)\b[a-zA-Z0-9-]+\.(?:com|net|org|io|co|dev|app|xyz|gg|so|ai|finance|protocol)(?:\/[^\s]*)?\b)|(#[a-zA-Z0-9_]+)/g

export function renderTextContent(content, onHashtagClick) {
  if (!content) return null

  const nodes = []
  let lastIndex = 0
  let match
  let key = 0
  CONTENT_TOKEN_REGEX.lastIndex = 0

  while ((match = CONTENT_TOKEN_REGEX.exec(content)) !== null) {
    if (match.index > lastIndex) {
      nodes.push(content.slice(lastIndex, match.index))
    }
    const [, url, hashtag] = match
    if (url) {
      const href = /^https?:\/\//i.test(url) ? url : `https://${url}`
      nodes.push(
        <a
          key={`link-${key++}`}
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          onClick={(e) => e.stopPropagation()}
          className="text-primary font-semibold break-all hover:underline"
        >
          {url}
        </a>
      )
    } else if (hashtag) {
      nodes.push(
        <button
          key={`tag-${key++}`}
          type="button"
          onClick={(e) => {
            e.stopPropagation()
            if (typeof onHashtagClick === 'function') onHashtagClick(hashtag)
          }}
          className="text-primary font-semibold hover:underline"
        >
          {hashtag}
        </button>
      )
    }
    lastIndex = CONTENT_TOKEN_REGEX.lastIndex
  }

  if (lastIndex < content.length) {
    nodes.push(content.slice(lastIndex))
  }

  return nodes
}
